<template>
  <div class="privacy">
    <h2>积分获取方法一览：</h2>
    <h5>2024年01月31日调整积分细则如下：</h5>
    <img src="../../assets/img/integral-privacy.jpg" alt="" />
    <!-- <img src="../../assets/img/integral-privacy2.jpg" alt="" /> -->

    <h4>免责说明：</h4>
    <p>※该积分只能应用与本平台的积分系统中。不可兑换现金。</p>
    <p>※该积分不可进行转让，也不可与其他会员的积分合并使用。</p>
    <p>※积分规则，会员等级，成就勋章等今后有可能发生变动，敬请谅解。</p>

    <h4 style="margin-top: 10px">奖品发放说明：</h4>
    <p>
      ※所有活动奖品统一安排采购，统一安排快递发放。
      每月28日安排当月兑换的奖品寄出，如果遇周六日顺延1~2日。
    </p>
    <p>※还请兑奖的朋友耐心等待奖品的到来。</p>
  </div>
</template>
<script>
export default {
  name: "Privacy",
  components: {},
  props: {
    // props: {
    //   type: String
    // }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  watch: {},
};
</script>
<style scoped>
.privacy {
  padding: 10px;
  background: #fff;
}
.privacy h2 {
  margin-bottom: 10px;
  text-align: center;
}
.privacy img {
  width: 100%;
}
.privacy img:nth-child(2) {
  margin-bottom: 20px;
}
.privacy img:nth-child(3) {
  margin-bottom: 20px;
}
.privacy h4 {
  margin-bottom: 5px;
}
.privacy p {
  text-indent: 1.5em;
  font-size: 15px;
  color: #707070;
}
</style>